import React from 'react'
import Header from './components/Header'
import FeaturesProduct from './components/FeaturesProduct'
import Service from './components/Service'
export default function Home() {
  return (
    <div>
        <Header/>
        <FeaturesProduct/>
        <Service/>
    </div>
  )
}
